import React, {useEffect, useState} from "react";
import {Business, CurrentUser} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import "./../../App.css"
import "./BusinessPage.css"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router";
import CustomerCardList from "../../components/card/CustomerCardList";
import BusinessLocationList from "../../components/location/BusinessLocationList";

interface Props {
  currentUser: CurrentUser | undefined,
  businessMap: Map<string, Business>,
}

function BusinessPage(props: Props) {
  const navigate = useNavigate();
  const [business, setBusiness] = useState<Business>();

  const { id: businessId } = useParams();

  useEffect(() => {
    setBusiness(props.businessMap.get(businessId || ""));
  }, [props.businessMap]);

  return (
      <>
        <AuthCheck />
        {business && <div>
          <div className={"mb-3"}>
            <div className={"primary-button"} onClick={() => navigate(`/business/configure`)}>
                <div className={"d-inline-block me-2"}>Configure Business</div>
                <FontAwesomeIcon icon={faCog}/>
            </div>
          </div>

            <div className={"basic-box"}>
                {/*<div className={"font-sm float-right tag green"}><b>{business.status}</b></div>*/}
                <div className={"font-1-4 centre-align"}><b>{business.name}</b></div>
            </div>

          <BusinessLocationList currentUser={props.currentUser} businessId={businessId} defaultDisplayList={true} />

          <CustomerCardList currentUser={props.currentUser} businessId={businessId} defaultDisplayList={true} />
        </div>}
      </>
  );
};

export default BusinessPage;
